import React, { useMemo } from 'react';
import { REPORT_TYPES, importRemote, report } from '@adsk/exo-skeleton-api';
import { getRemoteRuntime } from '@adsk/exo-skeleton-api/internal';
import { EXO_SKELETON_SCOPE_NAME, RETRY_IMPORT_REMOTE } from '../helpers/consts';

// eslint-disable-next-line @typescript-eslint/ban-types
export function useCreateLazyRemoteComponent(_ref) {
  let {
    moduleName,
    scope
  } = _ref;
  const {
    moniker,
    override
  } = getRemoteRuntime(scope) || {};
  return useMemo(() => /*#__PURE__*/React.lazy(() => importRemote({
    scope,
    module: moduleName,
    onRetry(_ref2) {
      let {
        error,
        retryName,
        tryAttempt
      } = _ref2;
      report({
        type: REPORT_TYPES.error,
        scope: EXO_SKELETON_SCOPE_NAME,
        value: RETRY_IMPORT_REMOTE,
        context: {
          moniker,
          override,
          retryName,
          tryAttempt,
          module,
          scope,
          error
        }
      });
    }
  })), [moduleName, scope, moniker, override]);
}
//# sourceMappingURL=useCreateLazyRemoteComponent.js.map